import { z } from 'zod'
import { oc } from '@orpc/contract'

/**
 * The caller's client has fetched the latest messages in these threads, so the
 * senders may now show them as Delivered.
 *
 * Threads whose newest message the caller sent themselves, or whose pointer is
 * already current, are skipped server-side — `acknowledged` lists only the
 * threads that actually moved.
 */
export const acknowledgeThreadDelivery = oc
  .route({ method: 'POST', path: '/v2/threads/acknowledge-delivery' })
  .input(z.object({ threadIds: z.array(z.string()).min(1).max(200) }))
  .output(z.object({ acknowledged: z.array(z.string()) }))
